import { push } from 'connected-react-router'
import { generatePresendAttributes } from 'conversations/utils/presend'
import { urlForConversation, urlForVisitor } from 'conversations/utils/urlUtils'
import { OpenConversationPayload } from 'shared/ipc/conversation/OpenConversationPayload'
import { OpenExternalLinkPayload } from 'shared/ipc/conversation/OpenExternalLinkPayload'
import { OpenVisitorPayload } from 'shared/ipc/conversation/OpenVisitorPayload'
import { SendConversationMessagePayload } from 'shared/ipc/conversation/SendConversationMessagePayload'
import { IpcChannel } from 'shared/ipc/IpcChannel'
import { sendMessageAsync } from 'shared/store/actions/message'
import { track } from 'shared/store/actions/tracking'
import { MessageContentType } from 'shared/typings/messages/MessageContentType'
import { MessageType } from 'shared/typings/messages/MessageType'

import { GlobalStore as store } from '@driftt/traffic-control'

import { getIpcService } from './ipc'

export const registerNotificationListeners = (): void => {
  const ipcService = getIpcService()

  ipcService.on<OpenConversationPayload, void>(
    IpcChannel.OPEN_CONVERSATION,
    (payload?: OpenConversationPayload) => {
      if (payload) {
        store.dispatch(push(urlForConversation(payload.conversationId)))
        store.dispatch(
          track({
            name: 'Notification Clicked',
            properties: { conversationId: payload.conversationId },
          })
        )
      } else {
        store.dispatch(track({ name: 'Notification Empty' }))
      }
      return Promise.resolve()
    }
  )

  ipcService.on<OpenExternalLinkPayload, void>(
    IpcChannel.OPEN_EXTERNAL_LINK,
    (payload?: OpenExternalLinkPayload) => {
      if (payload && payload.url) {
        window.open(payload.url)
        store.dispatch(
          track({
            name: 'External Link Notification Clicked',
            properties: { notificationType: payload.type, url: payload.url },
          })
        )
      } else {
        store.dispatch(track({ name: 'External Link Notification Empty' }))
      }
      return Promise.resolve()
    }
  )

  ipcService.on<OpenVisitorPayload, void>(
    IpcChannel.OPEN_VISITOR,
    (payload?: OpenVisitorPayload) => {
      if (payload) {
        store.dispatch(push(urlForVisitor(payload.endUserId)))
        store.dispatch(
          track({
            name: 'ABM Notification Clicked',
            properties: { endUserId: payload.endUserId, url: urlForVisitor(payload.endUserId) },
          })
        )
      } else {
        store.dispatch(track({ name: 'ABM Notification Empty' }))
      }
      return Promise.resolve()
    }
  )

  ipcService.on<SendConversationMessagePayload, void>(
    IpcChannel.SEND_CONVERSATION_MESSAGE,
    async (payload?: SendConversationMessagePayload) => {
      if (payload && payload.conversationId !== '') {
        store.dispatch(
          sendMessageAsync.request({
            conversationId: payload.conversationId,
            body: payload.messageText,
            type: MessageType.CHAT,
            contentType: MessageContentType.CHAT,
            ...generatePresendAttributes(),
          })
        )
        store.dispatch(track({ name: 'Inline Reply Sent' }))
      }
      return Promise.resolve()
    }
  )
}
